// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sized {\n  width: 1em;\n  height: 1em;\n}\n\n.textAligned {\n  position: relative;\n  top: 0.125em;\n}\n", "",{"version":3,"sources":["webpack://./node_modules/@nerdwallet/react-carousel/node_modules/@nerdwallet/react-icon/dist/svg-components/icon.module.less"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".sized {\n  width: 1em;\n  height: 1em;\n}\n\n.textAligned {\n  position: relative;\n  top: 0.125em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sized": "sized",
	"textAligned": "textAligned"
};
export default ___CSS_LOADER_EXPORT___;
